import { type PropsWithChildren, type CSSProperties } from 'react';

import {
  GLOBAL_LABEL_FONT_CSS_TOKEN,
  GLOBAL_TREND_FONT_CSS_TOKEN,
  GLOBAL_VALUE_FONT_CSS_TOKEN,
} from '../../core/components/single-value-renderer/constants.js';
import { useGlobalFontSize } from '../../core/components/single-value-renderer/hooks/use-global-font-size.js';
import { fontSizeWrapper } from './GlobalFontSizeVariables.sty.js';

/** A wrapper that holds the runtime css token variables of the global font size, to be accessed by child SingleValue components */
export const GlobalFontSizeVariables = ({ children }: PropsWithChildren) => {
  const { valueFontSize, labelFontSize, trendFontSize } = useGlobalFontSize();

  return (
    <div
      className={fontSizeWrapper}
      style={
        {
          [GLOBAL_VALUE_FONT_CSS_TOKEN]: valueFontSize,
          [GLOBAL_LABEL_FONT_CSS_TOKEN]: labelFontSize,
          [GLOBAL_TREND_FONT_CSS_TOKEN]: trendFontSize,
        } as CSSProperties
      }
    >
      {children}
    </div>
  );
};
